import React, { ReactNode, useState } from 'react'
import { FormulaireRechercheModel, INITIAL_FORMULAIRE_RECHERCHE } from '../types/formulaireRechercheModel'
import { ResultatRechercheModel } from '../types/rechercheModel'
import { INITIAL_RESULTAT_RECHERCHE } from './rechercheConstants'
import { champsMenuRechercheEnum, toutesLesLocalisations } from '../enums/champsMenuRecherche'

export interface RechercheContextProps {
	resultat: ResultatRechercheModel,
	setResultat: (resultat: ResultatRechercheModel) => void,
	loading: boolean,
	setLoading: (loading: boolean) => void,
	filtres: FormulaireRechercheModel,
	setFiltres: (filtres: FormulaireRechercheModel) => void,
	offreSurvolee: string | null,
	setOffreSurvolee: (offreSurvolee: string | null) => void,
	champTouche: boolean,
	setChampTouche: (champTouche: boolean) => void
	resetFiltresOffre: () => void
}

const resultat: ResultatRechercheModel = INITIAL_RESULTAT_RECHERCHE
const loading: boolean = false
const filtres: FormulaireRechercheModel = INITIAL_FORMULAIRE_RECHERCHE

export const RechercheContext = React.createContext<RechercheContextProps>({
	resultat,
	setResultat: (resultat) => {
	},
	loading,
	setLoading: (loading) => {
	},
	filtres,
	setFiltres: (filtres) => {
	},
	offreSurvolee: null,
	setOffreSurvolee: (offreSurvolee) => {
	},
	champTouche: false,
	setChampTouche: (champTouche) => {
	},
	resetFiltresOffre: () => {
	}
})

const RechercheProvider = (props: { children: ReactNode }) => {
	const [resultat, setResultat] = useState<ResultatRechercheModel>(INITIAL_RESULTAT_RECHERCHE)
	const [loading, setLoading] = useState<boolean>(false)
	// On affiche par défaut avec toutes les localisations
	const [filtres, setFiltres] = useState<FormulaireRechercheModel>({
		...INITIAL_FORMULAIRE_RECHERCHE,
		[champsMenuRechercheEnum.location]: toutesLesLocalisations
	})
	const [offreSurvolee, setOffreSurvolee] = useState<string | null>(null)
	const [champTouche, setChampTouche] = useState(false)

	const resetFiltresOffre = () => {
		setFiltres(INITIAL_FORMULAIRE_RECHERCHE)
		setResultat(INITIAL_RESULTAT_RECHERCHE)
	}

	return (
		<RechercheContext.Provider
			value={{
				resultat,
				setResultat,
				loading,
				setLoading,
				filtres,
				setFiltres,
				offreSurvolee,
				setOffreSurvolee,
				champTouche,
				setChampTouche,
				resetFiltresOffre
			}}
		>
			{props.children}
		</RechercheContext.Provider>
	)
}

export default RechercheProvider